import axios from 'axios';
import { API_URL } from './config';

/**
 * Axios instance used only for auth routes. Uses an explicit baseURL so login/register
 * always hit the configured API even if something else mutates the global axios.defaults.
 */
export const authApi = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});
